import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import {
  Dialog,
  Tabs, Tab,
} from '@blueprintjs/core';
import {Translate, I18n} from 'react-redux-i18n';

import {
  closePreviewDialog,
} from './ExerciseBenchmarkActions';
import {
  sendMessage,
} from '../ExerciseRun/CommunicationBoxActions'
import style from './PreviewDialog.module.css';

function PreviewBenchmarkDialog(props) {
  const location = useLocation();
  
  const [answers, setAnswers] = useState([]);
  const [notes, setNotes] = useState([]);
  const [benchmarks, setBenchmarks] = useState([]);
  const [exerciseName, setExerciseName] = useState('');
  const [exerciseCode, setExerciseCode] = useState('');
  
  useEffect(() => {
    // console.log("LOCATION", location);
    const state = JSON.parse(decodeURIComponent(location.search.split("state=")[1]));
    if(!state) {
      return console.log("State is not defined for", location.search, "and state value", state);
    }
    
    setAnswers(state.answers || []);
    setNotes(state.notes || []);
    setBenchmarks(state.benchmarks || []);
    setExerciseName(state.exerciseName || '');
    setExerciseCode(state.exerciseCode || '');
  }, [location.search]);
  
  console.log(benchmarks);
  
  return (
    <div style={{overflowY: 'auto'}}>
      {
        benchmarks.map((benchmark, cIndex) => (
          <div className={"col-sm-8 col-sm-offset-2"} key={"benchmark-"+cIndex}>
            <div className={`${style.printMainContainer}`}>
              <h3>
                {
                    exerciseName && <span><strong>Exercise Name: </strong> {exerciseName}</span>
                }
              </h3>
              <h3>
                {
                  exerciseCode && <span><strong>Exercise Code: </strong> {exerciseCode}</span>
                }
              </h3>
              <h4>{benchmark.name.toUpperCase()}</h4>
              <table className={`${style.qtable}`}>
                <tbody>
                {
                  benchmark.questions.map((question, index) => (
                    <tr key={"q-"+index}>
                      <td>
                        <span className={`${style.questionCount}`}>{index + 1}.</span>{question.title}  
                      </td>
                      <td>
                        <React.Fragment>
                          {
                            question.answers.map((answer, aIndex) => (
                              <span
                                className={`${style.answer} ${props.answerable? "pointer" : ""} ${(answers[cIndex] && (answers[cIndex][index] === aIndex))? style.highlightedAnswer : ""}`}
                                key={"q-"+index+"-a-"+aIndex}
                              >
                                {answer}
                              </span>
                            ))
                          }
                        </React.Fragment>
                      </td>
                      <td>
                        {
                          notes && !!notes.length &&
                          notes[cIndex]?.[index]
                        }
                      </td>
                    </tr> 
                  ))
                }
                </tbody>
              </table>
            </div>
          </div>
        ))
      }
  </div>
  )
}

const mapStateToProps = (state) => ({
  benchmark: state.exercise.benchmark,
  currentBenchmarks: state.exerciseBenchmark.currentBenchmarks,
  isPreviewBenchmarkDialogOpen: state.exerciseBenchmark.isPreviewBenchmarkDialogOpen,
});

const mapDispatchToProps = ({
  closePreviewDialog,
  sendMessage
})

export default connect(mapStateToProps, mapDispatchToProps)(PreviewBenchmarkDialog);